export default __webpack_public_path__ + "static/media/up_arrow_white.557045ea.svg";